import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SignIn from './SignIn.js';
import MainContent from './maincontent.js';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter,RouterProvider, HashRouter,Route,Routes} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <RouterProvider router={router} />
//   </React.StrictMode>
// );
root.render(
        <HashRouter>
          <Routes>
          <Route exact path="/" element={<SignIn/>}/>
          <Route exact path="/MainContent" element={<MainContent/>}/>
          </Routes>
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
